import './*.scss'

function init() {

}

export default init
